import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const InputsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const InputWrapper = styled.div`
  flex-grow: 1;
  max-width: 45%;
`
export const SliderWrapper = styled.div`
  margin-bottom: ${cssTheme.layout.spacing.s600};
  padding-bottom: ${cssTheme.layout.spacing.s300};
`

export const InputsSeparator = styled.div`
  display: flex;
  align-items: center;
  padding: 0 ${cssTheme.layout.spacing.s400};
`

export const RangeSliderWrapper = styled.div`
  margin: -5px 0 0px;
  padding: 0 ${cssTheme.layout.spacing.s500};
`

// This is provider for styles from rc-slider library
// Currently we don't use css loader in webpack.
// It was removed during migration to a new webpack version.
// So we're not able to import style from npm modules.
// We use theme colors only for elements we're currently use on the website
export const RangeSliderStylesProvider = styled.div`
  .rc-slider {
    position: relative;
    height: 14px;
    padding: 5px 0;
    width: 100%;
    border-radius: 6px;
    -ms-touch-action: none;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
  .rc-slider * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: ${cssTheme.colors.border.neutral.secondary};
    height: 2px;
    border-radius: 6px;
  }
  .rc-slider-track {
    position: absolute;
    left: 0;
    height: 2px;
    border-radius: 6px;
    background-color: ${cssTheme.colors.background.brand.inverse};
  }
  .rc-slider-handle {
    position: absolute;
    width: 28px;
    height: 28px;
    cursor: pointer;
    cursor: -webkit-grab;
    margin-top: -12px;
    cursor: grab;
    border-radius: 50%;
    border: solid 1px ${cssTheme.colors.border.neutral.secondary};
    background-color: ${cssTheme.colors.background.neutral.primary};
    box-shadow: ${cssTheme.shadows.fixed};
    -ms-touch-action: pan-x;
    touch-action: pan-x;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rc-slider-handle-click-focused:focus {
    border-color: ${cssTheme.colors.border.neutral.secondary};
  }
  .rc-slider-handle:hover {
    border-color: ${cssTheme.colors.border.neutral.secondary};
  }
  .rc-slider-handle:active {
    border-color: ${cssTheme.colors.border.neutral.secondary};
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  .rc-slider-mark {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
  }
  .rc-slider-mark-text {
    position: absolute;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    color: ${cssTheme.colors.content.neutral.disabled};
  }
  .rc-slider-mark-text-active {
    color: ${cssTheme.colors.content.neutral.secondary};
  }
  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: 4px;
    background: transparent;
  }
  .rc-slider-dot {
    position: absolute;
    bottom: -2px;
    margin-left: -4px;
    width: 8px;
    height: 8px;
    border: 2px solid ${cssTheme.colors.border.neutral.secondary};
    background-color: ${cssTheme.colors.background.neutral.primary};
    cursor: pointer;
    border-radius: ${cssTheme.layout.radius.rounded};
    vertical-align: middle;
  }
  .rc-slider-dot-active {
    border-color: ${cssTheme.colors.border.interactive.primaryActive};
  }
  .rc-slider-dot-reverse {
    margin-left: 0;
    margin-right: -4px;
  }
  .rc-slider-disabled {
    background-color: ${cssTheme.colors.background.neutral.tertiary};
  }
  .rc-slider-disabled .rc-slider-track {
    background-color: ${cssTheme.colors.background.neutral.tertiary};
  }
  .rc-slider-disabled .rc-slider-handle,
  .rc-slider-disabled .rc-slider-dot {
    background-color: ${cssTheme.colors.background.neutral.tertiary};
    box-shadow: none;
    background-color: ${cssTheme.colors.background.neutral.primary};
    cursor: not-allowed;
  }
  .rc-slider-disabled .rc-slider-mark-text,
  .rc-slider-disabled .rc-slider-dot {
    cursor: not-allowed !important;
  }
  .rc-slider-vertical {
    width: 14px;
    height: 100%;
    padding: 0 5px;
  }
  .rc-slider-vertical .rc-slider-rail {
    height: 100%;
    width: 4px;
  }
  .rc-slider-vertical .rc-slider-track {
    left: 5px;
    bottom: 0;
    width: 4px;
  }
  .rc-slider-vertical .rc-slider-handle {
    margin-left: -5px;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
  }
  .rc-slider-vertical .rc-slider-mark {
    top: 0;
    left: 18px;
    height: 100%;
  }
  .rc-slider-vertical .rc-slider-step {
    height: 100%;
    width: 4px;
  }
  .rc-slider-vertical .rc-slider-dot {
    left: 2px;
    margin-bottom: -4px;
  }
  .rc-slider-vertical .rc-slider-dot:first-of-type {
    margin-bottom: -4px;
  }
  .rc-slider-vertical .rc-slider-dot:last-child {
    margin-bottom: -4px;
  }
  .rc-slider-tooltip-zoom-down-enter,
  .rc-slider-tooltip-zoom-down-appear {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    display: block !important;
    animation-play-state: paused;
  }
  .rc-slider-tooltip-zoom-down-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    display: block !important;
    animation-play-state: paused;
  }
  .rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
  .rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
    animation-name: rcSliderTooltipZoomDownIn;
    animation-play-state: running;
  }
  .rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
    animation-name: rcSliderTooltipZoomDownOut;
    animation-play-state: running;
  }
  .rc-slider-tooltip-zoom-down-enter,
  .rc-slider-tooltip-zoom-down-appear {
    transform: scale(0, 0);
    animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  }
  .rc-slider-tooltip-zoom-down-leave {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  @keyframes rcSliderTooltipZoomDownIn {
    0% {
      opacity: 0;
      transform-origin: 50% 100%;
      transform: scale(0, 0);
    }
    100% {
      transform-origin: 50% 100%;
      transform: scale(1, 1);
    }
  }
  @keyframes rcSliderTooltipZoomDownOut {
    0% {
      transform-origin: 50% 100%;
      transform: scale(1, 1);
    }
    100% {
      opacity: 0;
      transform-origin: 50% 100%;
      transform: scale(0, 0);
    }
  }
  .rc-slider-tooltip {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: visible;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
  .rc-slider-tooltip * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
  .rc-slider-tooltip-hidden {
    display: none;
  }
  .rc-slider-tooltip-placement-top {
    padding: 4px 0 8px 0;
  }
  .rc-slider-tooltip-inner {
    padding: 6px 2px;
    min-width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 1;
    color: ${cssTheme.colors.background.neutral.primary};
    text-align: center;
    text-decoration: none;
    background-color: ${cssTheme.colors.background.neutral.inverseSecondary};
    border-radius: 6px;
    box-shadow: 0 0 4px ${cssTheme.colors.background.neutral.tertiary};
  }
  .rc-slider-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
    bottom: 4px;
    left: 50%;
    margin-left: -4px;
    border-width: 4px 4px 0;
    border-top-color: ${cssTheme.colors.background.neutral.inverseSecondary};
  }
`
